import { render, staticRenderFns } from "./ConfigureRuleField.vue?vue&type=template&id=2786fac9&scoped=true"
import script from "./ConfigureRuleField.vue?vue&type=script&lang=js"
export * from "./ConfigureRuleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786fac9",
  null
  
)

export default component.exports